interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: "primary" | "outline" | "danger" | "default";
    size?: "sm" | "md" | "lg" | "xs";
  }
  
  export const Button = ({ children, variant = "primary", size="md", className = "", ...props }: ButtonProps) => {
    const base = "px-4 py-2 font-medium rounded-md transition-transform";
    const variants = {
      primary: "bg-gray-700 text-white hover:bg-gray-800",
      outline: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100",
      danger: "bg-red-500 text-white hover:bg-red-600",
      default: "bg-white text-gray-900 border border-gray-200 hover:bg-gray-100 hover:text-gray-700",
    };

    const sizes = {
        xs: "h-6 px-3 m2 text-xs",
        sm: "h-8 px-4 m2 text-sm",
        md: "h-10 px-5 m2 text-md",
        lg: "h-12 px-6 m2 text-lg",
    }
  
    return (
      <button className={`${base} ${variants[variant]} ${sizes[size]}  ${className}`} {...props}>
        {children}
      </button>
    );
  };
  